import React, { useState, useLayoutEffect, useEffect } from 'react'
import PropTypes from 'prop-types'
import {
    FormCheckbox,
    FormCheckboxLabel,
    FormCheckboxMarker,
    FormMain,
    FormPrivacy,
    Fieldset
} from './index.style'
import Input from '@components/Input'
import Textarea from '@components/Textarea'
import Select from '@components/Select'
import Button from '@components/Button'
import Checkbox from '@components/Checkbox'
import IconArrowRight from '@svgs/IconArrowRight'
import RichText from '@components/RichText'
import IconTick from '@svgs/IconTick'
import { colors } from '@styles/vars/colors.style'
import gsap, {TweenLite} from 'gsap'

const Form = ({
    name,
    config,
    formSignupText,
    onSuccess,
    successText = "Thanks for sliding into our DM's",
    buttonColor = 'currentColor',
    customSubmit,
    customState,
    customButtonTitle,
    canSendAnother,
    removeLastCheck,
    formData
}) => {
    const initialState = {}
    for (const input of config) {
        initialState[input.name] = ''
    }
    var initRequired = [];
    useEffect(()=>{
        config.map(input => {
            if(input.required){
                initRequired[input.name] = {"value": "", "type": input.type};
            }
        });
    }, [config]);

    const [values, setValues] = useState(initRequired)
    const [formSent, setFormSent] = useState(false)
    const [formSuccessText, setFormSuccessText] = useState(successText)
    const [canSend, setCanSend] = useState(false);
    const [signupChecked, setSignupChecked] = useState(true)
    const [joinSub, setJoinSub] = useState(false);
    const [defaultJoin, setDefaultJoin] = useState(false);
    const [slideOpened, setSlideOpened] = useState(true);

    useEffect(()=>{
        if(customState){
            setFormSuccessText(customState);
            setFormSent(true);
        }
    }, [customState]);

    const encode = data => {
        const value = Object.keys(data).map(
            key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
        )
        return value.join('&')
    }

    const handleChecked = (e, required, join = false, checked = false) => {
        if(required) {
            if (e.target.checked) {
                setValues({ ...values, [e.target.name]: {value: true, type: 'checkbox'} })
            } else {
                setValues({ ...values, [e.target.name]: {value: "", type: 'checkbox'} })
            }
        }
        setDefaultJoin(true);
        if(join){
            if (e.target.checked) {
                setJoinSub(true);
                setDefaultJoin(true);
            } else {
                setJoinSub(false);
                setDefaultJoin(false);
            }
        }
    }

    useEffect(()=>{
        setCanSend(checkValidate());
    }, [values]);

    useEffect(()=>{
        if(canSendAnother) {
            if(!slideOpened){
                TweenLite.to('#formInputs', 0.7, {height:0, overflow: 'hidden'})
            }else{
                TweenLite.set('#formInputs', {height:"auto", overflow: 'unset'})
                TweenLite.from('#formInputs', 0.7, {height:0, overflow: 'hidden'})
            }
        }
    }, [slideOpened]);

    const sendAnother = () => {
        setSlideOpened(!slideOpened)
        setFormSent(false)
        setValues(initRequired)
    }

    const validateEmail = text => {
        const validRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (text.match(validRegex)) {
            return true;
        } else {
            return false;
        }
    }

    const checkValidate = () => {
        var check = true;
        if(values) {
            Object.keys(values)?.map((item, key) => {
                if(!values[item].value) {
                    check = false;
                }else {
                    if(values[item].type === 'email') {
                        check = validateEmail(values[item].value);
                    }
                }
            });
            return check;
        }
        return false;
    }

    const handleSubmit = e => {

        e.preventDefault()
        
        const data = {
            'form-name': name,
            subject: 'Site form submission',
        }

        for (const input of config) {
            data[input.name] = values[input.name].value
        }

        if(joinSub || defaultJoin) {
            const elem = document.getElementById('mce-EMAIL');
            const form = document.getElementById('mc-embedded-subscribe-form');
            elem.value = values['Email'].value;
            form.submit();
        }

        fetch('/', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: encode(data),
            })
            .then(() => {
                setFormSent(true)
                setSlideOpened(!slideOpened)

                if (onSuccess) {
                    onSuccess()
                }
            })
            .catch(error => alert(error))
    }

    const netlifyInt = (name === 'Contact form') ? {'data-netlify': true} : {}

    return (
        <FormMain
          name={name}
          method="POST"
          onSubmit={customSubmit ? customSubmit : handleSubmit}
          {...netlifyInt}
        >
            <Fieldset id="formInputs">
            {React.Children.toArray(
                config.map(input => (
                <>
                {(input.type === 'input' || input.type === 'email') && (
                    <Input
                        id={`form-${input.name}`}
                        name={input.name}
                        label={input.label}
                        value={values[input.name]?.value}
                        type={input.type}
                        onChange={e =>
                          setValues({ ...values, [input.name]: {value: e.target.value, type: input.type} })
                        }
                        required
                    />
                )}

                {input.type === 'textarea' && (
                    <Textarea
                        id={`form-${input.name}`}
                        name={input.name}
                        label={input.label}
                        value={values[input.name]?.value}
                        rows="5"
                        onChange={e =>
                          setValues({ ...values, [input.name]: {value: e.target.value, type: input.type} })
                        }
                        required
                    />
                )}

                {input.type === 'select' && (
                    <Select
                        id={`form-${input.name}`}
                        name={input.name}
                        label={input.label}
                        value={values[input.name]?.value}
                        onChange={e =>
                          setValues({ ...values, [input.name]: {value: e.target.value, type: input.type} })
                        }
                        options={input.options}
                        required
                    />
                )}

                {input.type === 'checkbox' && (
                    <Checkbox
                        id={`form-${input.name}`}
                        name={input.name}
                        required={input.required}
                        checked={input.checked}
                        onChange={(e) => handleChecked(e, input.required, input.join, input.checked)}
                    >
                    {input.label}
                    </Checkbox>
                )}
                </>
                ))
            )}
            </Fieldset>

            {!formSent && (
                <Button
                  variant="text"
                  disabled={!canSend}
                  iconRight={<IconArrowRight />}
                  onClick={() => {}}
                  color={buttonColor}
                  type="submit"
                >
                  {customButtonTitle ? customButtonTitle : 'Send message'}
                </Button>
            )}

            {formSent && 
                <>
                {removeLastCheck && <p>{formSuccessText}</p>}
                {canSendAnother && 
                    <Button
                      variant="text"
                      disabled={!canSend}
                      iconRight={<IconArrowRight />}
                      onClick={() => {sendAnother()}}
                      color={buttonColor}
                      type="button"
                    >
                      Send Another message
                    </Button>
                }
                </>
            }
        </FormMain>
    )
}

Form.propTypes = {
    name: PropTypes.string,
    formSignupText: PropTypes.object,
    config: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default Form